<app-modal-window [title]="'Промокод #' + data.id"
                  [actions]="false"
                  (close)="close()">

  <div class="promo-info-loading" *ngIf="isLoading">
    <mat-spinner diameter="24"></mat-spinner>
  </div>

  <div class="promo-info-empty" *ngIf="!isLoading && notFound">
    Промокод не найден.
  </div>

  <div class="promo-info" *ngIf="!isLoading && promo as p">
    <dl class="promo-info-grid">
      <dt>ID</dt>
      <dd>{{ p.id }}</dd>

      <dt>Код</dt>
      <dd>{{ p.code || '-' }}</dd>

      <dt>Тип</dt>
      <dd>{{ p.type }}</dd>

      <dt>Значение</dt>
      <dd>
        <ng-container *ngIf="p.type === 'money'; else percentValue">{{ p.amount / 100 | currency: 'USD' }}</ng-container>
        <ng-template #percentValue>{{ p.amount }}%</ng-template>
      </dd>

      <dt>% отыгрыша</dt>
      <dd>{{ p.payback_percentage ?? '-' }}</dd>

      <dt>Wallet type</dt>
      <dd>{{ p.wallet_type }}</dd>

      <dt>User type</dt>
      <dd>{{ p.user_type }}</dd>

      <dt>Лимит / использовано / активаций</dt>
      <dd>{{ p.use_limit ?? '∞' }} / {{ p.used }} / {{ p.activations }}</dd>

      <dt>Лимит на юзера</dt>
      <dd>{{ p.individual_use_limit ?? '∞' }}</dd>

      <dt>Min deposit</dt>
      <dd>{{ p.min_deposit_sum != null ? (p.min_deposit_sum / 100 | currency: 'USD') : '-' }}</dd>

      <dt>Max reward (legacy)</dt>
      <dd>{{ p.max_reward_amount != null ? (p.max_reward_amount / 100 | currency: 'USD') : '-' }}</dd>

      <dt>Owner bonus % / owner id</dt>
      <dd>{{ p.owner_bonus_percentage ?? '-' }} / {{ p.owner_user_id ?? '-' }}</dd>

      <dt>Disabled / Visible all</dt>
      <dd>{{ p.disabled ? 'Да' : 'Нет' }} / {{ p.visible_all ? 'Да' : 'Нет' }}</dd>

      <dt>Действует с</dt>
      <dd>{{ p.activation_start_at ? (p.activation_start_at | date: 'dd.MM.yy HH:mm') : '-' }}</dd>

      <dt>Действует до</dt>
      <dd>{{ p.activation_end_at ? (p.activation_end_at | date: 'dd.MM.yy HH:mm') : '-' }}</dd>

      <dt>Комментарий</dt>
      <dd>{{ p.comment || '-' }}</dd>
    </dl>

    <div class="promo-info-rewards" *ngIf="p.rewards?.length">
      <h4>Награды</h4>
      <table class="promo-info-rewards-table">
        <tr>
          <th>ID</th>
          <th>Тип</th>
          <th>Item ID</th>
          <th>Значение</th>
          <th>Reward Price</th>
        </tr>
        <tr *ngFor="let reward of p.rewards">
          <td>{{ reward.id }}</td>
          <td>{{ reward.type }}</td>
          <td>{{ reward.item_id ?? '-' }}</td>
          <td>{{ reward.value ?? '-' }}</td>
          <td>
            <ng-container *ngIf="rewardPrice(reward) as rp; else noPrice">
              <ng-container *ngIf="rp.money; else rawPrice">{{ rp.amount / 100 | currency: 'USD' }}</ng-container>
              <ng-template #rawPrice>{{ rp.amount }}</ng-template>
            </ng-container>
            <ng-template #noPrice>-</ng-template>
          </td>
        </tr>
      </table>
    </div>
  </div>

</app-modal-window>
